import styled from "styled-components";
import Letter from "./Letter";
import {
  VIEWBOX_WIDTH,
  VIEWBOX_HEIGHT,
  GRADIENT_COLORS,
  phrase,
} from "./constants";
import Tree from "./Tree";

const StyledSignatureContainer = styled.section`
  width: 300px;
  max-height: 90px;
  aspect-ratio: 300 / 90;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-end;
  padding: 1rem;
`;

const StyledSVG = styled.svg`
  width: 100%;
`;

const LinearGradientDef = () => {
  const animateDef = {
    stopColor: [
      {
        offset: "0%",
        initial: GRADIENT_COLORS.start,
        attributeName: "stop-color",
        values: `${GRADIENT_COLORS.start};${GRADIENT_COLORS.middle};${GRADIENT_COLORS.start}`,
        dur: "2s",
        repeatCount: "indefinite",
      },
      {
        offset: "50%",
        initial: GRADIENT_COLORS.middle,
        attributeName: "stop-color",
        values: `${GRADIENT_COLORS.middle};${GRADIENT_COLORS.end};${GRADIENT_COLORS.middle}`,
        dur: "2s",
        repeatCount: "indefinite",
      },
      {
        offset: "100%",
        initial: GRADIENT_COLORS.end,
        attributeName: "stop-color",
        values: `${GRADIENT_COLORS.end};${GRADIENT_COLORS.start};${GRADIENT_COLORS.end}`,
        dur: "2s",
        repeatCount: "indefinite",
      },
    ],
  };

  return (
    <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
      {animateDef.stopColor.map(
        (
          { offset, initial, attributeName, values, dur, repeatCount },
          index
        ) => (
          <stop {...{ stopColor: initial, offset }}>
            <animate
              attributeName={attributeName}
              values={values}
              dur={dur}
              repeatCount={repeatCount}
            />
          </stop>
        )
      )}
    </linearGradient>
  );
};

function Signature() {
  const letterEntries = Object.entries({
    F: phrase,
  });

  return (
    <StyledSignatureContainer>
      <Tree index={0} />
      <StyledSVG
        viewBox={`0 0 ${VIEWBOX_WIDTH} ${VIEWBOX_HEIGHT}`}
        height="100%"
        preserveAspectRatio="xMidYMid meet"
      >
        <defs>
          <LinearGradientDef />
        </defs>

        {letterEntries.map(([key, path], index) => (
          <Letter key={key} path={path} index={index} />
        ))}
      </StyledSVG>
      <Tree index={0} />
    </StyledSignatureContainer>
  );
}

export default Signature;
